import { type FC, type PropsWithChildren, createContext, useContext, useMemo, useState } from "react";
import mbc from "~/shared/functions/mbc";

type FlytState<T> = {
	setState(state: Partial<T> | ((prev: T) => void)): void;
} & T;

const FlytStateContext = createContext({} as FlytState<any>);

const defaultRadgivningsState = {
	okonomiSvar: {},
	risikoSvar: [],
	baerekraftSvar: [],
	erfaringSvar: [],
	anbefaling: {},
};

interface FlytStateProviderProps extends PropsWithChildren {
	initialState?: object;
}

// TODO: Denne skal fjernes når vi er over på jotai i alle flytene
export const FlytStateProvider: FC<FlytStateProviderProps> = ({ initialState = {}, children }) => {
	const mobileState = mbc.getInitialState();
	const [state, setState] = useState({ ...defaultRadgivningsState, ...initialState, ...mobileState?.flyt });

	const set = (val) => {
		if (typeof val === "function") {
			setState((prev) => ({ ...prev, ...val(prev) }));
		} else {
			setState((prev) => ({ ...prev, ...val }));
		}
	};

	const value = useMemo(
		() => ({
			...state,
			setState: set,
		}),
		[state],
	);

	return <FlytStateContext.Provider value={value}>{children}</FlytStateContext.Provider>;
};

export function useFlytState<T = any>() {
	return useContext<FlytState<T>>(FlytStateContext);
}
